import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../style/pages/agency.css";
import * as Listing from "./components/listing";
import { MAP_TILER_APIKEY, MAP_TILER_VALUATION_ZOOM_AGENCY_DETAILS, MAP_TILER_STYLE } from "./components/variables";
import axios from "axios";
// @ts-ignore
import FiltersRealEstateInAgency from "@vueEntry/FiltersRealEstateInAgency.vue";
// @ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
// @ts-ignore
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
// @ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import { useModals } from "@wkComposables/useModals";
import CommonModals from "./vue/CommonComponents/CommonModals";
//@ts-ignore
import { useFavourite } from "@wkComposables/useFavourite";
//@ts-ignore
import { useContactAgencyModal } from "@wkComposables/useContactAgencyModal";
//@ts-ignore
import { useShowPhone } from "@wkComposables/useShowPhone";
//@ts-ignore
import { useShareModal } from "@wkComposables/useShareModal";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import AccessibleSelect from "@vueEntry/UIKitComponents/AccessibleSelect.vue";
//@ts-ignore
import { useSearch } from "@wkComposables/useSearch";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseIcon from "@vueEntry/UIKitComponents/BaseIcon.vue";
//@ts-ignore
import SwiperSlide from "@vueEntry/SwiperCarousel/SwiperSlide.vue";
//@ts-ignore
import IntersectionObserverVue from "@vueEntry/IntersectionObserver/IntersectionObserverVue.vue";
//@ts-ignore
import BaseBadge from "@vueEntry/UIKitComponents/BaseBadge.vue";
//@ts-ignore
import IntersectionObservableVue from "@vueEntry/IntersectionObserver/IntersectionObservableVue.vue";
import { createApp, defineAsyncComponent } from "vue";
import { mapActions, mapState, createPinia } from "pinia";
import { useBaseStore, useSearchBeanStore, useLoggedUserStore, usePublicUserMenuStore, useModalStore, useMetadataStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import { handleInsertionClick } from "@wkWebSrc/js/components/insertion";
//@ts-ignore
import { handleBreadcrumbLinkClick } from "@wkWebSrc/js/components/navigationBreadcrumb";
//@ts-ignore
import { transformReImages } from "@utils/ImageUtils";
//@ts-ignore
import { IMAGE_FORMATS } from "@customTypes/ImageFormatsEnum";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { useUtilities } from "@wkComposables/useUtilities";
//@ts-ignore
import { MailIcon } from "@vueEntry/SvgIcons/MailIcon";
//@ts-ignore
import { PhoneIcon } from "@vueEntry/SvgIcons/PhoneIcon";
//@ts-ignore
import { redirectToApp } from "@utils/AppRedirectUtils";
var loadImage = src => new Promise((resolve, reject) => {
  var image = new Image();
  image.onload = () => {
    resolve(src);
  };
  image.onerror = () => {
    reject(src);
  };
  image.src = src;
});
var agencyBox = {
  data: {
    heightParagraph: 0,
    heightContainer: 0,
    hideButton: true
  },
  onMounted(vueInstance) {
    var _a, _b, _c, _d;
    // @ts-ignore
    vueInstance.heightContainer = (_b = (_a = vueInstance.$refs.agencyDescriptionContainer) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0;
    // @ts-ignore
    vueInstance.heightParagraph = (_d = (_c = vueInstance.$refs.agencyDescriptionParagraph) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 0;
    // @ts-ignore
    if (vueInstance.heightParagraph > vueInstance.heightContainer) {
      // @ts-ignore
      vueInstance.hideButton = false;
    }
  }
};
var filterModalContentAgency = {
  components: {
    FiltersRealEstateInAgency
    // Modal
  },
  data: {
    isClosed: false,
    openModal: false,
    isMobile: false
  },
  onMounted(vueInstance) {
    if (window.screen.width < BREAKPOINT.SMALL) {
      //@ts-ignore
      vueInstance.isMobile = true;
    }
  },
  methods: {
    transformReImages,
    handleBreadcrumbLinkClick,
    handleInsertionClick,
    useApp() {
      redirectToApp("Dettaglio agenzia - Banner");
    },
    search(e) {
      // @ts-ignore
      this.$refs.FiltersRealEstateInAgency.search(e);
    },
    reset() {
      // @ts-ignore
      this.$refs.FiltersRealEstateInAgency.resetFilter();
    },
    closeModal() {
      // @ts-ignore
      this.$refs.modalFilterAgency.closeModal();
    }
  }
};
var agencyContainer = {
  data: {
    agentsList: [],
    start: 0,
    leftOffset: 0
  },
  methods: vueInstance => ({
    getAgent() {
      return axios.get("/rest/agency/getPublicAgentsData/".concat(window["_agencyID"], "/").concat(vueInstance.start, "/0")).then(response => {
        return response.data;
      });
    }
  }),
  onMounted(vueInstance) {
    axios.get("/rest/agency/getPublicAgentsData/".concat(window["_agencyID"], "/").concat(vueInstance.start, "/0")).then(response => {
      return response.data;
    }).then(agents => {
      vueInstance.agentsList = agents.value;
      // to remove the splide arrow if only one agent is present
      if (agents.key <= 1) vueInstance.options.classes.arrows = "d-none";
    });
  }
};
var agencyApp = createApp({
  name: "AgencyDetails",
  components: Object.assign(Object.assign(Object.assign(Object.assign({
    BaseButton,
    //@ts-ignore
    SwiperCarousel: defineAsyncComponent(() => import("@vueEntry/SwiperCarousel.vue")),
    SwiperSlide,
    AccessibleSelect,
    BaseIcon,
    PublicUserMenu,
    BaseBadge,
    IntersectionObserverVue,
    IntersectionObservableVue,
    PhoneIcon,
    MailIcon,
    //@ts-ignore
    "share-modal": defineAsyncComponent(() => import("./vue/Modals/ShareModal.vue")),
    //@ts-ignore
    "contact-agency-modal": defineAsyncComponent(() => import("./vue/Modals/ContactAgencyModal.vue")),
    //@ts-ignore
    "filters-re-agency-modal": defineAsyncComponent(() => import("./vue/Modals/FiltersRealEstateInAgencyModal.vue")),
    //@ts-ignore
    "orders-modal": defineAsyncComponent(() => import("./vue/Modals/OrderModal.vue")),
    //@ts-ignore
    "agency-details-modal": defineAsyncComponent(() => import("./vue/Modals/AgencyDetailsModal.vue")),
    //@ts-ignore
    "badge-modal": defineAsyncComponent(() => import("./vue/Modals/BadgeModal.vue"))
  }, filterModalContentAgency.components), {
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseDropDown.vue"))
  }), LanguageIcons), CommonModals),
  setup() {
    var {
      displayPhone,
      phoneLabel,
      showPhone
    } = useShowPhone();
    var {
      isAppBannerVisible
    } = useAppBanner();
    var {
      handleAddFavorite,
      handleRemoveFavorite
    } = useFavourite();
    var {
      agencyModalData,
      reopenAfterLogin,
      successModalDataEmitted,
      amdLabels,
      amdIcons,
      listingType,
      openContactModal,
      openAndReturnToCAMS
    } = useContactAgencyModal();
    var {
      setShowModal,
      openAndReturnTo
    } = useModals();
    var {
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick
    } = useFirebaseMessaging();
    var {
      search,
      setOrderAndSearch,
      setOrderAndSearchInAgency
    } = useSearch();
    var {
      shareModalData,
      openShareModal,
      gaEvent
    } = useShareModal();
    var {
      isLarge
    } = useBreakpoints();
    var {
      redirectTo
    } = useUtilities();
    return {
      isLarge,
      displayPhone,
      phoneLabel,
      showPhone,
      isAppBannerVisible,
      setShowModal,
      openAndReturnTo,
      //Contact Agency Modal (CAM)
      //CAM state
      agencyModalData,
      reopenAfterLogin,
      successModalDataEmitted,
      //CAM computed
      amdLabels,
      amdIcons,
      listingType,
      //CAM methods
      openContactModal,
      openAndReturnToCAMS,
      //Favourites methods
      handleAddFavorite,
      handleRemoveFavorite,
      //useFirebaseMessaging
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick,
      //useSearch
      search,
      setOrderAndSearch,
      setOrderAndSearchInAgency,
      //useShareModal
      shareModalData,
      openShareModal,
      gaEvent,
      redirectTo
    };
  },
  data() {
    return Object.assign(Object.assign(Object.assign({
      listMode: true
    }, agencyContainer.data), agencyBox.data), filterModalContentAgency.data);
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    IMAGE_FORMATS() {
      return IMAGE_FORMATS;
    },
    orderOptions() {
      return window["orderOptions"];
    },
    orderSelected() {
      return this.orderOptions.find(option => option.id === this.searchBean.filterOrderId) || {
        id: 0
      };
    },
    staticMapImageUrl() {
      // eslint-disable-next-line max-len
      return "https://api.maptiler.com/maps/".concat(MAP_TILER_STYLE, "/static/").concat(window["_longitude"], ",").concat(window["_latitude"], ",").concat(MAP_TILER_VALUATION_ZOOM_AGENCY_DETAILS, "/620x360@2x.png?key=").concat(MAP_TILER_APIKEY);
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(useSearchBeanStore, ["searchBean"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name"])), mapState(useModalStore, ["showModal"])), mapState(useMetadataStore, ["pageName"])),
  created() {
    return __awaiter(this, void 0, void 0, function* () {
      this.updateSearchBean(JSON.parse(window._serializedSearchBean));
      yield this.initPublicUserMenu();
      if (!this.isMobile) {
        loadImage(this.staticMapImageUrl).then(url => {
          this.$refs.mapImage.style.backgroundImage = "url('".concat(url, "')");
        });
      }
    });
  },
  mounted() {
    agencyContainer.onMounted(this);
    agencyBox.onMounted(this);
    filterModalContentAgency.onMounted(this);
    Listing.init({
      list: "#list-properties"
    });
  },
  methods: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    goToDetail(detailURL) {
      location.href = detailURL;
    },
    openFilterAgencyModal() {
      this.openModal = true;
    }
  }, agencyContainer.methods(this)), filterModalContentAgency.methods), mapActions(useBaseStore, ["logout", "initPublicUserMenu"])), mapActions(useSearchBeanStore, ["updateSearchBean"])), {
    sendGAEvent,
    openBadgeModal() {
      sendGAEvent("top_agency_widget_open_modal", {
        event_location: "agenzia-immobiliare"
      });
      this.setShowModal("BADGE_MODAL");
    }
  })
});
agencyApp.use(createPinia());
agencyApp.mount("#agency-details-main");
window["goToMarketingBadge"] = goToMarketingBadge;
export function goToMarketingBadge(baseUrl) {
  window.location.href = baseUrl + "?agency=" + window.location.pathname;
}